import React, { useContext, useState } from "react";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonNote,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { DataContext } from "../context/DataContext";
import Toolbar from "../components/Toolbar";

const Login: React.FC = () => {
  const MIN_PASSWORD_LENGTH = 8;
  const VERIFY_EMAIL_STORAGE_KEY = "verifyEmailAddress";

  const history = useHistory();
  const {
    appLoggedIn,
    appLoggedInChange,
    appUserData,
    appUserDataChange,
    appTokenChange
  } = useContext(DataContext);

  const { control, handleSubmit } = useForm();

  const [segment, setSegment] = useState<string>("login");
  const [loginEmail, setLoginEmail] = useState<string>("");
  const [loginPass, setLoginPass] = useState<string>("");
  const [registerPassConfirm, setRegisterPassConfirm] = useState<string>("");
  const [vorname, setVorname] = useState<string>("");
  const [nachname, setNachname] = useState<string>("");
  const [mobiltelefon, setMobiltelefon] = useState<string>("");
  const [datenschutz, setDatenschutz] = useState<boolean>(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const [loginPassTouched, setLoginPassTouched] = useState(false);
  const [registerPassConfirmTouched, setRegisterPassConfirmTouched] = useState(false);
  const [vornameTouched, setVornameTouched] = useState(false);
  const [nachnameTouched, setNachnameTouched] = useState(false);
  const [mobiltelefonTouched, setMobiltelefonTouched] = useState(false);
  const [datenschutzTouched, setDatenschutzTouched] = useState(false);
  const [loginSubmitted, setLoginSubmitted] = useState(false);
  const [registerSubmitted, setRegisterSubmitted] = useState(false);

  const validateEmail = (email: string) => {
    return email.match(
      /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
    );
  };

  const normalizeMobilePhone = (phone: string) =>
    phone.replace(/[\s\-/().]/g, "");

  const validateMobilePhone = (phone: string) => {
    const normalized = normalizeMobilePhone(phone);
    return /^(?:\+49|0)1[5-7][0-9]{8,9}$/.test(normalized);
  };

  const validate = (ev: any) => {
    const value = String(ev?.detail?.value ?? ev?.target?.value ?? "");
    setEmailTouched(true);
    setLoginEmail(value);
  };

  const markEmailTouched = () => {
    setEmailTouched(true);
  };
  const [loginInfoMessage, setLoginInfoMessage] = useState("");

  const validatePass = (ev: any) => {
    const value = String(ev?.detail?.value ?? ev?.target?.value ?? "");
    setLoginPassTouched(true);
    setLoginPass(value);
  };

  const emailTrimmed = loginEmail.trim();
  const emailIsValid = emailTrimmed !== "" && validateEmail(emailTrimmed) !== null;
  const emailShouldShowError = emailTouched || loginSubmitted || registerSubmitted;
  const emailHasError = emailShouldShowError && !emailIsValid;
  const passwordLength = loginPass.length;
  const passwordTooShort = loginPass !== "" && passwordLength < MIN_PASSWORD_LENGTH;
  const passwordErrorText =
    loginPass === ""
      ? "Bitte geben Sie ein Passwort ein"
      : `Mindestens ${MIN_PASSWORD_LENGTH} Zeichen erforderlich.`;
  const loginPassHasError =
    (loginPassTouched || loginSubmitted) && (loginPass === "" || passwordTooShort);
  const vornameHasError = (vornameTouched || registerSubmitted) && vorname.trim() === "";
  const nachnameHasError = (nachnameTouched || registerSubmitted) && nachname.trim() === "";
  const mobiltelefonTrimmed = mobiltelefon.trim();
  const mobiltelefonIsValid =
    mobiltelefonTrimmed !== "" && validateMobilePhone(mobiltelefonTrimmed);
  const mobiltelefonHasError =
    (mobiltelefonTouched || registerSubmitted) && !mobiltelefonIsValid;
  const registerPassHasError =
    (loginPassTouched || registerSubmitted) && (loginPass === "" || passwordTooShort);
  const registerPassConfirmEmpty = registerPassConfirm === "";
  const registerPassMismatch = !registerPassConfirmEmpty && loginPass !== registerPassConfirm;
  const registerPassConfirmHasError =
    (registerPassConfirmTouched || registerSubmitted) &&
    (registerPassConfirmEmpty || registerPassMismatch);
  const registerPassConfirmErrorText = registerPassConfirmEmpty
    ? "Bitte wiederholen Sie das Passwort"
    : "Die Passwörter stimmen nicht überein";
  const datenschutzHasError = (datenschutzTouched || registerSubmitted) && !datenschutz;

  const isRegisterFormComplete =
    loginEmail.trim() !== "" &&
    emailIsValid &&
    vorname.trim() !== "" &&
    nachname.trim() !== "" &&
    mobiltelefonIsValid &&
    loginPass.length >= MIN_PASSWORD_LENGTH &&
    registerPassConfirm !== "" &&
    loginPass === registerPassConfirm &&
    Boolean(datenschutz);

  const doLogin = () => {
    setLoginSubmitted(true);
    //alert('wird eingeloggt.'+loginEmail+' pass: '+loginPass)
    if (!emailIsValid) {
      return;
    }
    if (loginPass === "" || passwordTooShort) {
      return;
    }
    localStorage.setItem(VERIFY_EMAIL_STORAGE_KEY, loginEmail.trim());
    const formData = new FormData();
    formData.append("loginEmail", loginEmail);
    formData.append("loginPass", loginPass);
    formData.append("betribe_id", "81");

    fetch(
      "https://login.saint-online.de/funktionen/api2/campusmenu/getLogin.php",
      { method: "POST", body: formData }
    )
      .then((response) => response.json())
      .then((data) => {
        // 
        if (data.status == 200) {
          appLoggedInChange(true);
          appUserDataChange(data.data);
          appTokenChange(data.token)
          history.push('/home')

        }
        else if (data.status == 403) {
          alert("Benurzername oder Passwort falsch");
        }
        else if (data.status == 406) {
          appUserDataChange(data.data);
          appTokenChange(data.token);
          history.push('/confirm-email');
        }
        else if (data.status == 409) {
          appUserDataChange(data.data);
          appTokenChange(data.token);
          history.push('/confirm-phone-code');
        }
        else if (data.status == 426) {
          alert("Bitte vergeben Sie ein neues Passwort.");
          appLoggedInChange(true);
          appUserDataChange(data.data);
          appTokenChange(data.token)
          history.push('/PR')
        }
        else {
          alert(JSON.stringify(data.msg));
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error.msg));
      });
  };

  const doRegister = () => {
    setRegisterSubmitted(true);
    //alert('wird eingeloggt.'+loginEmail+' pass: '+loginPass)
    if (!emailIsValid) {
      return;
    }
    if (loginPass === "" || passwordTooShort) {
      return;
    }
    if (registerPassConfirm === "") {
      return;
    }
    if (loginPass !== registerPassConfirm) {
      return;
    }
    if (vorname === "") {
      return;
    }
    if (nachname === "") {
      return;
    }
    if (!mobiltelefonIsValid) {
      return;
    }
    if (!datenschutz) {
      return;
    }

    localStorage.setItem(VERIFY_EMAIL_STORAGE_KEY, loginEmail.trim());

    const formData = new FormData();
    formData.append("loginEmail", loginEmail);
    formData.append("loginPass", loginPass);
    formData.append("vorname", vorname);
    formData.append("nachname", nachname);
    formData.append("mobiltelefon", normalizeMobilePhone(mobiltelefon));
    formData.append("datenschutz", datenschutz ? "1" : "0");
    formData.append("betribe_id", "81");

    fetch(
      "https://login.saint-online.de/funktionen/api2/campusmenu/setRegister.php",
      { method: "POST", body: formData }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          history.push('/confirm-email');
        } else if (data.status == 405) {
          setLoginInfoMessage("Das Konto existiert bereits. Bitte melden Sie sich an.");
          setSegment("login");
        } else {
          alert(JSON.stringify(data.msg));
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error.msg ?? error));
      });
  };



  return (
    <IonPage>

      <IonContent fullscreen>
        <IonHeader>
          <Toolbar />
        </IonHeader>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>
              <IonSegment value={segment}>
                <IonSegmentButton
                  value="login"
                  onClick={() => setSegment("login")}
                >
                  <IonLabel>Anmelden</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton
                  value="register"
                  onClick={() => setSegment("register")}
                >
                  <IonLabel>Registrieren</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            {segment && segment === "login" ? (
              <>
                <form className="ion-padding" onSubmit={handleSubmit(doLogin)}>
                  {loginInfoMessage !== "" && (
                    <IonNote color="warning" className="ion-padding-start ion-margin-bottom" style={{ display: "block" }}>
                      {loginInfoMessage}
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">E-Mail</IonLabel>

                    <IonInput
                      className={`${emailIsValid && !emailHasError && "ion-valid"} ${emailHasError && "ion-invalid"
                        } ${emailShouldShowError && "ion-touched"}`}
                      name="username"
                      autocomplete="username"
                      autocapitalize="off"
                      spellcheck={false}
                      type="email"
                      fill="solid"
                      labelPlacement="floating"
                      // helperText="Bitte geben Sie eine Mail-Adresse ein"
                      errorText="Bitte geben Sie eine gültige E-Mail-Adresse an."
                      onIonInput={(event) => validate(event)}
                      onIonBlur={() => markEmailTouched()}
                      value={loginEmail}
                    ></IonInput>
                  </IonItem>
                  {emailHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      Bitte geben Sie eine gültige E-Mail-Adresse an.
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">Passwort</IonLabel>
                    <IonInput
                      className={`${loginPassHasError && "ion-invalid"} ${(loginPassTouched || loginSubmitted) && "ion-touched"}`}
                      name="password"
                      autocomplete="current-password"
                      type="password"
                      fill="solid"
                      labelPlacement="floating"
                      errorText={passwordErrorText}
                      onIonChange={(e) => validatePass(e)}
                      onIonBlur={() => setLoginPassTouched(true)}
                      value={loginPass}
                    ></IonInput>
                  </IonItem>
                  {loginPassHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      {passwordErrorText}
                    </IonNote>
                  )}
                  <IonButton expand="full" type="submit">
                    Anmelden
                  </IonButton>
                  <IonButton
                    color="warning"
                    //expand="full"
                    onClick={() => setSegment("register")}
                  >
                    Noch kein Konto?
                  </IonButton>
                </form>
              </>
            ) : segment && segment === "register" ? (
              <>

                <form className="ion-padding" onSubmit={handleSubmit(doRegister)}>
                  <IonItem>
                    <IonLabel position="floating">E-Mail</IonLabel>

                    <IonInput
                      className={`${emailIsValid && !emailHasError && "ion-valid"} ${emailHasError && "ion-invalid"
                        } ${emailShouldShowError && "ion-touched"}`}
                      name="username"
                      autocomplete="username"
                      autocapitalize="off"
                      spellcheck={false}
                      type="email"
                      fill="solid"
                      labelPlacement="floating"
                      //helperText="Bitte geben Sie eine Mail-Adresse ein"
                      errorText="Bitte geben Sie eine gültige E-Mail-Adresse an."
                      onIonInput={(event) => validate(event)}
                      onIonBlur={() => markEmailTouched()}
                      value={loginEmail}
                    ></IonInput>
                  </IonItem>
                  {emailHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      Bitte geben Sie eine gültige E-Mail-Adresse an.
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">Vorname</IonLabel>
                    <IonInput
                      className={`${vornameHasError && "ion-invalid"} ${(vornameTouched || registerSubmitted) && "ion-touched"}`}
                      name="given-name"
                      autocomplete="given-name"
                      type="text"
                      fill="solid"
                      labelPlacement="floating"
                      errorText="Bitte geben Sie einen Vornamen ein"
                      value={vorname}
                      onIonChange={(e: any) => { setVorname(e.detail.value ?? ""); setVornameTouched(true); }}
                      onIonBlur={() => setVornameTouched(true)}
                    ></IonInput>
                  </IonItem>
                  {vornameHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      Bitte geben Sie einen Vornamen ein
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">Familienname</IonLabel>
                    <IonInput
                      className={`${nachnameHasError && "ion-invalid"} ${(nachnameTouched || registerSubmitted) && "ion-touched"}`}
                      name="family-name"
                      autocomplete="family-name"
                      type="text"
                      fill="solid"
                      labelPlacement="floating"
                      errorText="Bitte geben Sie einen Nachnamen ein"
                      value={nachname}
                      onIonChange={(e: any) => { setNachname(e.detail.value ?? ""); setNachnameTouched(true); }}
                      onIonBlur={() => setNachnameTouched(true)}

                    ></IonInput>
                  </IonItem>
                  {nachnameHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      Bitte geben Sie einen Nachnamen ein
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">Mobiltelefonnummer</IonLabel>
                    <IonInput
                      className={`${mobiltelefonHasError && "ion-invalid"} ${(mobiltelefonTouched || registerSubmitted) && "ion-touched"}`}
                      name="tel"
                      autocomplete="tel"
                      type="tel"
                      fill="solid"
                      labelPlacement="floating"
                      errorText="Bitte geben Sie eine gültige Mobiltelefonnummer an"
                      value={mobiltelefon}
                      onIonChange={(e: any) => { setMobiltelefon(e.detail.value ?? ""); setMobiltelefonTouched(true); }}
                      onIonBlur={() => setMobiltelefonTouched(true)}
                    ></IonInput>
                  </IonItem>
                  {mobiltelefonHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      Bitte geben Sie eine gültige Mobiltelefonnummer an
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">Passwort</IonLabel>
                    <IonInput
                      className={`${registerPassHasError && "ion-invalid"} ${(loginPassTouched || registerSubmitted) && "ion-touched"}`}
                      name="password"
                      autocomplete="new-password"
                      type="password"
                      fill="solid"
                      labelPlacement="floating"
                      errorText={passwordErrorText}
                      onIonChange={(e) => validatePass(e)}
                      onIonBlur={() => setLoginPassTouched(true)}
                      value={loginPass}
                    ></IonInput>
                  </IonItem>
                  {registerPassHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      {passwordErrorText}
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel position="floating">Passwort wiederholen</IonLabel>
                    <IonInput
                      className={`${registerPassConfirmHasError && "ion-invalid"} ${(registerPassConfirmTouched || registerSubmitted) && "ion-touched"}`}
                      name="new-password-repeat"
                      autocomplete="new-password"
                      type="password"
                      fill="solid"
                      labelPlacement="floating"
                      errorText={registerPassConfirmErrorText}
                      onIonChange={(e: any) => { setRegisterPassConfirm(e.detail.value ?? ""); setRegisterPassConfirmTouched(true); }}
                      onIonBlur={() => setRegisterPassConfirmTouched(true)}
                      value={registerPassConfirm}
                    ></IonInput>
                  </IonItem>
                  {registerPassConfirmHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      {registerPassConfirmErrorText}
                    </IonNote>
                  )}
                  <IonItem>
                    <IonLabel>Ich habe die Datenschutzerklärung (<a href="https://www.kunterbunte-kueche.de/datenschutzerklaerung/" target="_blank" rel="noreferrer">hier öffnen</a>) zur Kenntnis genommen.</IonLabel>
                    <IonCheckbox checked={datenschutz} onIonChange={(e: any) => { setDatenschutz(Boolean(e.detail.checked)); setDatenschutzTouched(true); }} />
                  </IonItem>
                  {datenschutzHasError && (
                    <IonNote color="danger" className="ion-padding-start ion-margin-bottom">
                      Bitte stimmen Sie der Datenschutzerklärung zu
                    </IonNote>
                  )}


                  <IonButton expand="full" type="submit" disabled={!isRegisterFormComplete}>
                    weiter
                  </IonButton>
                </form>
              </>
            ) : (
              ""
            )}
          </IonCardContent>
        </IonCard>
        <IonCard>
          Version 1.3.0.5352
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default Login;
